module.exports = __webpack_public_path__ + "img/Mbongeni Quntana.4c059b4e.png";